import React, { useState, useEffect, useRef } from "react";
import { Menu, X } from "lucide-react";

function HeaderRedesign() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <>
      <header className="relative bg-white shadow-md">
        <div className="flex items-center justify-between px-4 py-3">
          {/* Hamburger */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-2xl text-gray-800 focus:outline-none"
          >
            <Menu className="w-6 h-6 text-gray-800" />
          </button>

          {/* Logo */}
          <div className="absolute transform -translate-x-1/2 left-1/2">
            <img src="/images/ford-logo.svg" alt="Ford" className="h-8" />
          </div>
        </div>
        {isMenuOpen && (
          <>
            <div
              ref={menuRef}
              className="absolute top-0 left-0 w-64 h-screen bg-white shadow-md z-[999]"
            >
              <button
                onClick={() => setIsMenuOpen(false)}
                className="absolute text-gray-800 top-4 right-4"
              >
                <X className="w-5 h-5" />
              </button>
              <ul className="flex flex-col p-4 space-y-2">
                <li>
                  <a
                    href="#"
                    onClick={() => setIsMenuOpen(false)}
                    className="text-gray-800 hover:text-blue-600"
                  >
                    Начало
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={() => setIsMenuOpen(false)}
                    className="text-gray-800 hover:text-blue-600"
                  >
                    Модели
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    onClick={() => setIsMenuOpen(false)}
                    className="text-gray-800 hover:text-blue-600"
                  >
                    Контакти
                  </a>
                </li>
              </ul>
            </div>
          </>
        )}
      </header>
      {isMenuOpen && (
        <div
          className="fixed inset-0 z-[998] bg-black opacity-50"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </>
  );
}

export default HeaderRedesign;
